import * as Yup from "yup";

const digitsOnly = (value) => /^\d+$/.test(value);

const AddUserValidation = Yup.object({
  Username: Yup.string()
    .required("Username is required")
    .matches(
      /^[a-zA-Z0-9_.]*$/,
      "Username can only include letters, numbers, underscores, and periods."
    ),
  FirstName: Yup.string().required("First Name is required"),
  LastName: Yup.string().required("Last Name is required"),
  Address: Yup.string()
    .required("Address is required")
    .test(
      "not-only-numbers",
      "Address cannot be only numbers.",
      (value) => !digitsOnly(value)
    ),
  EmailAddress: Yup.string()
    .required("Email Address is required!")
    .matches(
      /^[a-zA-Z0-9._-]+@[a-zA-Z]+\.[a-zA-Z.]{2,}$/,
      "Email is invalid! Must follow the format: username@domain.com"
    ),
  roles: Yup.array()
    .of(
      Yup.object({
        value: Yup.string().required("Role value is required"),
        label: Yup.string().required("Role label is required"),
      })
    )
    .min(1, "At least one role is required")
    .required("Roles are required"),
  PhoneNumber: Yup.string()
    .required("Phone number is required!")
    .test("Digits only", "Phone number must contain only digits!", digitsOnly)
    .test(
      "Exact length",
      "Phone number must be exactly 10 digits!",
      (value) => value && value.length === 10
    ),
  Password: Yup.string()
    .required("Password is required!")
    .min(8, "Password is too short - should be at least 8 characters.")
    .max(50, "Password is too long - should be at most 50 characters.")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])(?=.{8,})/,
      "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character."
    )
    .matches(/^\S*$/, "Password must not contain leading or trailing spaces."),
  ConfirmPassword: Yup.string()
    .oneOf([Yup.ref("Password"), null], "Passwords must match")
    .required("Confirm password is required!"),
});

export default AddUserValidation;

// import * as Yup from "yup";

// const digitsOnly = (value) => /^\d+$/.test(value);

// const AddUserValidation = Yup.object({
//   Username: Yup.string().required("Username is required"),
//   FirstName: Yup.string().required("First Name is required"),
//   LastName: Yup.string().required("Last Name is required"),
//   EmailAddress: Yup.string()
//     .required("Email Address is required!")
//     .matches(
//       /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
//       "Email is invalid!"
//     ),
//   roles: Yup.array()
//     .of(
//       Yup.object({
//         value: Yup.string().required("Role value is required"),
//         label: Yup.string().required("Role label is required"),
//       })
//     )
//     .min(1, "At least one role is required")
//     .required("Roles are required"),
//   PhoneNumber: Yup.string()
//     .test("Digits only", "Please enter only digits!", digitsOnly)
//     .test(
//       "Exact length",
//       "Phone number must be of 10 digits!",
//       (value) => value && value.length === 10
//     )
//     .required("Phone number is required!"),
//   Password: Yup.string()
//     .required("Password is required!")
//     .min(8, "Password is too short - should be 8 chars minimum.")
//     .matches(
//       /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#\$%\^&\*])(?=.{8,})/,
//       "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
//     ),
//   ConfirmPassword: Yup.string()
//     .oneOf([Yup.ref("Password"), null], "Passwords must match")
//     .required("Confirm password is required!"),
// });

// export default AddUserValidation;
